export default {
  strict: true,
  namespaced: true,
  state: {
    driverInbound: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      orderAsc: 1,
      isLoading: false,
      licenseType: 'all'
    }
  },
  mutations: {
    resetdriverInboundList (state) { state.driverInbound.list = [] },
    adddriverInbound (state, value) { state.driverInbound.list.push(value) },
    setdriverInboundIsLoading (state, value) { state.driverInbound.isLoading = value },
    setdriverInboundLicenseType (state, value) { state.driverInbound.licenseType = value },
    setdriverInboundCurrentPage (state, value) { state.driverInbound.currentPage = value },
    setdriverInboundMaxList (state, value) { state.driverInbound.maxList = value }
  }
};



// WEBPACK FOOTER //
// ./src/store/laxit/driver-inbound.js